<template>
    <div>
        <header-nav :cur="4" />
        <!-- 搜索 -->
        <div class="nav">
            <div class="navtab">
                <span class="top">
                    首页&nbsp;>
                    <span class="infor">考试</span>
                </span>
                <div class="newbox">
                    <div>
                        <div class="newtop">在这里检测您的学习成果</div>
                        <div class="newbot">加入班级，更快速的成长</div>
                    </div>
                    <div class="input">
                        <input placeholder="请输入您想要寻找的课程" type="text" />
                        <div class="select">搜索</div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 考试须知 -->
        <div class="navtab notice" v-if="!identity">
            <p>考试须知</p>
            <h4>欢迎您来到新动力学习。新动力的使命是帮助外语学习者实现学习梦想，更快、更好地掌握外语。为加强管理，提高教学质量，请大家注意以下事项：</h4>
            <h3>
                一、报名流程：
                <h4>前来咨询或报名的学员请务必认真阅读此报名须知，一旦缴费之后，即可视为您认可本学校的一切规定，并成为一种协议。</h4>
            </h3>
            <h3>
                二、报名流程：
                <h4>
                    阅读相关课程资料-----了解开课时间----确定要报班次-----填写报名登记表-----交缴学费------取得收据和考勤卡------确定报到时间
                    <br />
                    注：1、学员也可在新动力网上报名。(网址：www.newpower.org.cn)
                    <br />
                    2、学员自报名之日起一个月内可凭听课证开具发票，过期一律不予补开。
                    <br />
                    3、学员所报班级不足开班人数时, 新动力保留不开班的权利。
                    <br />
                    4、开班日期以各校区当月开课时间为准，请学员在开课前三天致电报名校区确认具体开课时间。
                    <br />
                    5、所报课程自课程第一次开课(第一次开课指学校课程按开课时间正常开课，而不是学员第一次上课)之日起365天内有效，超过365天因学员自身原因仍未开始上课时，则视同
                    学员 自动放弃对课程的学习，学员不得再办理退费、转班、延期、插班等相关手续。
                </h4>
            </h3>
            <h3>
                三、优惠制度：
                <h4>
                    1、在读老学员报名享受原价格的9折优惠，不在读老学员报名享受原价格的9.5折优惠，学员续报名时，须持本人原听课证方可享受以上优惠。备注：以上优惠方案为业余制课
                    程的优惠方案，脱产全日课程请详细咨询校区咨询老师。
                    <br />
                    2、持正规学校学生证、教师证、军官证、残疾证者可享受50元优惠。
                    <br />
                    3、连报优惠(此条也适用于老学员)：新动力课程配有几个级别连报的课程，优惠价格幅度比较大，请详细咨询校区的课程咨询老师。
                    <br />
                    4、持外校听课证来我校报同语种科目课程的，报名可享受业余制课程原价的9.5折优惠。
                    <br />
                    5、凡我校四六级班学生在参加我校四六级辅导一年内参加四六级考试成绩在650分者可获得奖金500元。
                    <br />
                    6、凡以学习券抵用报名费报名(使用优惠券报名折抵现金不超过学费的30%)，属报名优惠活动。学习券不能兑换现金。
                    <br />
                    7、我校如果同时有各项优惠活动进行，学员只能选择其中一种优惠，对于
                </h4>
            </h3>
            <div class="agree">
                <div class="auto-login">
                    <input type="checkbox" name="" id="" v-model="msg" />
                    <span>我已阅读保密须知并遵守相关规则。</span>
                </div>
                <div class="next" @click="next(identity)">下一步</div>
            </div>
        </div>
        <!-- 确认身份 -->
        <div class="navtab" v-if="identity">
            <p>准考证</p>
            <div class="indentbox">
                <img src="../../assets/img/index/course.jpg" alt="" />
                <table id="customers">
                    <tr>
                        <td>姓名：易烊千玺</td>
                        <td>满分：100分</td>
                    </tr>
                    <tr>
                        <td>准考证号：59875354</td>
                        <td>及格线：80分</td>
                    </tr>
                    <tr>
                        <td>身份证号：142563269987546985</td>
                        <td>是否有证书：是</td>
                    </tr>
                    <tr>
                        <td>报考科目：一级建造师</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>考试时间：2022年-2月-25日</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>考试时长：120分钟</td>
                        <td></td>
                    </tr>
                </table>
            </div>
            <div class="start" @click="exanbegin(official)">开始考试</div>
        </div>

        <footer-nav />
    </div>
</template>
<script>
import Vue from 'vue';
import { Toast } from 'vant';

Vue.use(Toast);
import headerNav from '../../components/HeaderNav.vue';
import footerNav from '../../components/FooterBar';
export default {
    components: {
        headerNav,
        footerNav,
    },
    data() {
        return {
            msg: '',
            identity: false,
            official: true,
        };
    },
    methods: {
        next() {
            if (this.msg == true) {
                this.identity = true;
            } else {
                Toast('请您先同意保密须知');
            }
        },
        exanbegin(off) {
            this.$router.push({ path: '/exam/exercise', query: { off } });
        },
    },
};
</script>
<style lang="less" scoped>
    // 公共
    .navtab {
        width: 1280px;
        margin: 0 auto;
    }
    .color {
        color: #2961EF !important;
    }
    .ignore {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
    }
    // 搜索
    .nav {
        background: #f7f8fa;
        width: 100%;
        height: 177px;
        .top {
            display: block;
            font-size: 16px;
    
            font-weight: 300;
            color: #777777;
            padding: 19px 0 24px;
            .infor {
                color: #2961EF;
            }
        }
        .newbox {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .newtop {
                font-size: 26px;
                color: #000000;
                margin-bottom: 5px;
            }
            .newbot {
                font-size: 16px;
                color: #888888;
            }
            .input {
                width: 497px;
                height: 59px;
                background: #ffffff;
                box-shadow: 3px 3px 10px 1px rgba(11, 19, 72, 0.050980392156862744);
                border-radius: 30px;
                position: relative;
                input {
                    border: none;
                    position: absolute;
                    left: 30px;
                    top: 0;
                    height: 59px;
                    line-height: 59px;
                    width: 365px;
                    font-size: 16px;
    
                    font-weight: 300;
                    color: #777777;
                }
                .select {
                    position: absolute;
                    right: 12px;
                    top: 8px;
                    width: 74px;
                    height: 43px;
                    line-height: 43px;
                    background: #2961EF;
                    border-radius: 30px;
                    font-size: 16px;
    
                    font-weight: 300;
                    color: #ffffff;
                    text-align: center;
                }
            }
        }
    }
    // 考试须知
    .notice {
        font-size: 16px;
        p {
            text-align: center;
            font-size: 30px;
            color: #333333;
            margin: 51px auto;
        }
        h3 {
            color: #333333;
            font-weight: bolder;
            line-height: 50px;
        }
        h4 {
            color: #666666;
            line-height: 40px;
            margin-left: 30px;
        }
        .agree {
            height: 65px;
            background: #f7f8fa;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 25px;
            margin: 33px 0 84px;
            span {
                margin-left: 14px;
            }
            .next {
                width: 107px;
                height: 39px;
                line-height: 39px;
                text-align: center;
                background: #2961EF;
                border-radius: 5px 5px 5px 5px;
                font-size: 16px;
                color: #ffffff;
            }
        }
    }
    // 确认身份
    p {
        text-align: center;
        font-size: 30px;
        color: #333333;
        margin: 51px auto;
    }
    .indentbox {
        display: flex;
        width: 988px;
        height: 310px;
        background: #ffffff;
        border-radius: 5px 5px 5px 5px;
        border: 15px solid #f7f8fa;
        margin: 0 auto;
        img {
            width: 220px;
            height: 100%;
        }
        #customers {
            border-collapse: collapse;
            width: 100%;
            td {
                border: 1px solid #ddd;
                width: 50%;
                padding-left: 30px;
                font-size: 16px;
                color: #000000;
            }
        }
    }
    .start {
        width: 157px;
        height: 39px;
        line-height: 39px;
        text-align: center;
        background: #2961EF;
        border-radius: 5px 5px 5px 5px;
        font-size: 16px;
        color: #ffffff;
        margin: 56px auto 85px;
    }
    
</style>